import { canViewRefunds } from '../global_context/capabilities/refundCapabilities'
import { canViewClients } from '../global_context/capabilities/clientCapabilities'
import { canViewProducts } from '../global_context/capabilities/productCapabilities'
import { canViewSegments } from '../global_context/capabilities/segmentCapabilities'
import { canViewEssentials } from '../global_context/capabilities/essentialCapabilities'
import { canViewPriceLists, canViewSpecialPrices } from '../global_context/capabilities/priceCapabilities'
import { canViewPromotions } from '../global_context/capabilities/promoCapabilities'
import { canViewUsersApp } from '../global_context/capabilities/userAppCapabilities'
import { canViewRoutePlans } from '../global_context/capabilities/routePlanCapabilities'
import { canViewPosTasks } from '../global_context/capabilities/posCapabilities'
import { canViewAssetReports, canViewCloseAssets } from '../global_context/capabilities/assetCapabilities'
import { canViewOnBoardSales } from '../global_context/capabilities/onBoardSaleCapabilities'
import { canViewOrders } from '../global_context/capabilities/orderCapabilities'
import { canViewDeliveries } from '../global_context/capabilities/deliveryCapabilities'
import { canViewCharges } from '../global_context/capabilities/chargeCapabilities'
import { canViewSettlements } from '../global_context/capabilities/settlementCapabilities'
import { canViewPocFillRate, canViewPocOrders } from '../global_context/capabilities/pocCapabilities'
import { canViewReports } from '../global_context/capabilities/reportCapabilities'

/**
 * Acceso del Inicio = permiso RBAC del catálogo + flag de tenant.
 *
 * Flags (variant.json → FlagProvider):
 * - shouldCreateOrder → Pedidos
 * - hasAppEntrega → Entregas
 * - useCobro → Cobros
 * - hasTenantReport → marca tenants con producto de reportes (referencia)
 */
export function getHomeCapabilities({
  variants = {},
  shouldCreateOrder = false,
  hasAppEntrega = false,
  hasTenantReport = false,
  canViewReport = false,
  useCobro: useCobroFlag
} = {}) {
  const useCobro =
    useCobroFlag != null ? Boolean(useCobroFlag) : Boolean(variants?.useCobro)
  const reportPermission = Boolean(canViewReport) || canViewReports()

  const pedidos = canViewOrders() && Boolean(shouldCreateOrder)
  const entregas = canViewDeliveries() && Boolean(hasAppEntrega)
  const cobros = useCobro && canViewCharges()
  const liquidaciones = canViewSettlements()
  const ordenesOc = canViewPocOrders()
  const reportes = reportPermission
  const todayKpis = reportPermission

  return {
    flags: {
      useCobro,
      shouldCreateOrder: Boolean(shouldCreateOrder),
      hasAppEntrega: Boolean(hasAppEntrega),
      hasTenantReport: Boolean(hasTenantReport)
    },

    clientes: canViewClients(),
    productos: canViewProducts(),
    segmentos: canViewSegments(),
    infaltables: canViewEssentials(),
    precios: canViewPriceLists() || canViewSpecialPrices(),
    promociones: canViewPromotions(),
    usuarios: canViewUsersApp(),
    planVisitas: canViewRoutePlans(),
    pos: canViewPosTasks(),
    activos: canViewAssetReports() || canViewCloseAssets(),
    ventaABordo: canViewOnBoardSales(),

    pedidos,
    entregas,
    cobros,
    liquidaciones,
    ordenesOc,
    fillRate: canViewPocFillRate(),
    reportes,
    devoluciones: canViewRefunds(),
    todayKpis,

    queueLiquidaciones: liquidaciones,
    queueOcErrors: ordenesOc,
    queuePedidosPorFacturar: pedidos,
    queueCobrosHoy: cobros,
    queueEntregasHoy: entregas
  }
}
